// client/src/components/Registration/Registration.js

import React from 'react';
import './Registration.css';

const Registration = () => {
  return (
    <section className="registration-section">
      <div className="registration-container">
        <h2>Official Registration</h2>
        <p className="registration-subtitle">
          Join Om Nidhi Productions today. Click the button below to fill out our official registration form via Google Forms.
        </p>
        
        {/* This button opens the Google Form in a new tab */}
        <a 
          href="https://forms.gle/9uvkR8kW1XAazj4N8" 
          target="_blank" 
          rel="noopener noreferrer"
          className="registration-button"
        >
          Open Registration Form
        </a>

      </div>
    </section>
  );
};

export default Registration;